import {SearchModel} from "../catalog/models/search.model";
import {FilterModel} from "../catalog/models/filter.model";

export interface Report {
  applicationReportId: number;
  name: string;
}

export enum ReportType {
  sales = 1,
  debt = 2
}

export interface ActualSaleInputModel{
  supplierId: number;
  outletIds: number[]
  productWithFilter: Array<FilterModel>;
  searchModel: SearchModel;
  filterExcludeProducts: Array<{productId: number}>
}

export interface ActualSaleReportModel{
  actualSales: ActualSales[];
  filters: Array<FilterModel>;
  productWithFilter: Array<FilterModel>;
  searchModel: SearchModel;
}

export interface ActualSales{
  date: Date;
  factAmount: number;
  factQty: number;
}

export interface DebtReportInputModel{
  supplierId: number;
  outletIds: number[]
  sort: DebtReportSortType;
  skip: number;
  take: number;
}

export enum DebtReportSortType
{
  DateDesc = 0,
  DateAsc = 1
}

export interface DebtReportModel{
  totals: DebtReportTotalsModel;
  items: Array<DebtReportItemModel>;
}

interface DebtReportTotalsModel {
  debtSum: number;
  debtOverdueSum: number;
  itemsCount: number;
}

export interface DebtReportItemModel {
  supplierOutletId: number;
  supplierOutletName: string;
  supplierOutletAddress: string;
  date: Date;
  debt: number;
  comment: string;
  debtTypeId: number;
  debtTypeName: string;
  debtOverdue: number;
  debtOverdueDelay: number;
  debtStatus: DebtStatus;
}
export enum DebtStatus
{
  NotPaid = 0,
  Overdue = 1,
}
